// *******************************************************
// Window
// -------------------------------------------------------
// This is a root SVG Container for the each page of the
// game to sit within
// -------------------------------------------

// *******************************************
// Module Imports
// -------------------------------------------
import React, { Component } from 'react';
// --------------------------------

// *******************************************
// Component Imports
// -------------------------------------------

// --------------------------------

// *******************************************
// Constant Imports
// -------------------------------------------
import { Dimensions, Routes } from '../constants';
// --------------------------------

// *******************************************
// Utility Imports
// -------------------------------------------

// --------------------------------

// *******************************************
// Style Imports
// -------------------------------------------
import { Animation, Fill } from '../styles';
// --------------------------------

class Title extends Component {

    render() {

        const { width, height, xPos, yPos } = this.props;
        const x = (Dimensions.SVG_VIEW_WIDTH - width) / 2;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={863} height={81} x={600} y={80} viewBox="0 0 863.33 81.38">
            <defs>
                <style>
                    {`.title-text-cls-1{fill:#fff}.title-text-cls-2{fill:#cdc5d5}`}
                </style>
            </defs>
            <title>
                Heading
            </title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="text">
                    <path class="title-text-cls-1" d="M.25,8.36c-1-4.18,1-6.71,5.28-6.71h7.81c3.63,0,5.83,1.76,6.6,5.39l8.8,43.78a45.58,45.58,0,0,1,1,8.25H30a43.44,43.44,0,0,1,1.32-8.25L42.05,6.93c.88-3.52,3.08-5.28,6.71-5.28h4.73q5.44,0,6.6,5.28L70.65,50.82A43.44,43.44,0,0,1,72,59.07h.22a45.58,45.58,0,0,1,1-8.25L82.75,6.93c.77-3.52,3-5.28,6.71-5.28h7.48c4.29,0,6.27,2.53,5.28,6.71L85.28,75.13c-.88,3.52-3.08,5.17-6.71,5.17H67.9c-3.63,0-5.83-1.76-6.71-5.28L52.61,40.59a67,67,0,0,1-1.54-9.24h-.22a67,67,0,0,1-1.54,9.24L40.73,75c-.88,3.52-3.08,5.28-6.71,5.28H23.13c-3.63,0-5.83-1.76-6.71-5.28Z"/>
                    <path class="title-text-cls-2" d="M109.37 7.7c0-4 2.09-6 6-6h6.93c4 0 6 2.09 6 6V26.51c0 2.86-.22 4.84-.22 4.84h.22c3.19-5.61 9.79-9 17.27-9 11.44 0 20.35 5.28 20.35 21.23V74.25c0 4-2.09 6-6 6H153c-4 0-6-2.09-6-6V47.08c0-5.28-2.09-7.48-6.27-7.48-8.25 0-12.32 6.49-12.32 15.18V74.25c0 4-2.09 6-6 6h-6.93c-4 0-6-2.09-6-6zM204.63 45h1.65V44c0-4.73-3.85-6.27-8-6.27A25.49 25.49 0 0 0 188 40.26c-3.63 1.54-6.38.88-8.14-2.64l-1.32-2.75c-1.65-3.41-1-6.38 2.42-8.14a45.29 45.29 0 0 1 19-4.4c15.62 0 25.3 8.69 25.3 23.1V74.25c0 4-2.09 6-6 6H214c-4 0-6-2-6-6.16V73.7a5 5 0 0 1 .11-1.1h-.22a20.25 20.25 0 0 1-16.72 9c-10.89 0-18.48-7.48-18.48-17.27C172.62 49.17 190.66 45 204.63 45zm-7.81 22.44c5.5 0 9.68-5.39 9.68-10V55.88h-1.76c-5.83 0-13.31 1.54-13.31 6.71C191.43 65.23 193.3 67.43 196.82 67.43zM238.73 39.49h-1.65c-3.85 0-5.94-2.09-5.94-6.05V30.69c0-4 2.09-6 6-6h2.09V14.41c0-4 2.09-6.05 6-6.05h6.38c4 0 6 2.09 6 6.05V24.64h5.83c4 0 6 2.09 6 6v2.75c0 4-2.09 6.05-5.94 6.05h-5.94V56.65c0 4.84 3.19 6.71 6.6 7.15 4.4.55 6 1.87 6 6v5c0 4.51-2.75 6-7.81 6-8.36 0-23.87-3.85-23.87-20.68z"/>
                    <path class="title-text-cls-1" d="M325.19,18.15H307.37c-4,0-6-2.09-6-6V7.7c0-4,2.09-6,6-6h54.89c4,0,6,2.09,6,6v4.4c0,4-2.09,6-6,6H344.44v56.1c0,4-2.09,6-6,6h-7.15c-4,0-6-2.09-6-6Z"/>
                    <path class="title-text-cls-2" d="M373.37 7.7c0-4 2.09-6 6-6h6.93c4 0 6 2.09 6 6V26.51c0 2.86-.22 4.84-.22 4.84h.22c3.19-5.61 9.79-9 17.27-9 11.44 0 20.35 5.28 20.35 21.23V74.25c0 4-2.09 6-6 6H417c-4 0-6-2.09-6-6V47.08c0-5.28-2.09-7.48-6.27-7.48-8.25 0-12.32 6.49-12.32 15.18V74.25c0 4-2.09 6-6 6h-6.93c-4 0-6-2.09-6-6zM466.76 22.33c16.83 0 26.18 11.88 26.18 27.06a6.51 6.51 0 0 1-6.38 6.27H456.75c1.43 6.93 7.15 10.12 13.2 10.12a23.54 23.54 0 0 0 10.34-2.64c3.63-1.65 6.27-1.21 8.14 2.31L490 68.31c1.76 3.41 1.21 6.38-2.09 8.25a39.54 39.54 0 0 1-19.47 5.06c-20.24 0-31.13-14.63-31.13-29.7C437.28 35.31 448.5 22.33 466.76 22.33zm7.37 22.44c0-4.62-3-8.47-7.81-8.47-5.5 0-8.14 4-9.13 8.47z"/>
                    <path class="title-text-cls-1" d="M530.22,7.7c0-4,2.09-6,6-6h36.08c4,0,6.05,2.09,6.05,6v4.4c0,4-2.09,6-6.05,6H549.47v16.5H567.4c4,0,6.05,2.09,6.05,6v4.4c0,4-2.09,6.05-6.05,6.05H549.47v23.1c0,4-2.09,6-6,6h-7.15c-4,0-6-2.09-6-6Z"/>
                    <path class="title-text-cls-2" d="M612.17 22.33c17.93 0 32.23 12 32.23 29.81s-14.3 29.48-32.12 29.48-32.12-11.77-32.12-29.48S594.46 22.33 612.17 22.33zm.11 43.45c6.93 0 12.87-5.17 12.87-13.64s-5.94-14-12.87-14-12.87 5.39-12.87 14S605.35 65.78 612.28 65.78zM681.25 22.33c17.93 0 32.23 12 32.23 29.81s-14.3 29.48-32.12 29.48-32.12-11.77-32.12-29.48S663.54 22.33 681.25 22.33zm.11 43.45c6.93 0 12.87-5.17 12.87-13.64s-5.94-14-12.87-14-12.87 5.39-12.87 14S674.43 65.78 681.36 65.78zM744.39 22.33c11.44 0 14.85 5.61 14.85 5.61h.22s-.11-1.1-.11-2.53V7.7c0-4 2.09-6 6.05-6h6.93c4 0 6 2.09 6 6V74.25c0 4-2.09 6-6 6h-5.72c-4 0-6.05-1.87-6.05-5.5v-.66a6.17 6.17 0 0 1 .11-.77h-.22s-4.73 8.25-16.39 8.25c-15.4 0-25.52-12.1-25.52-29.7C718.54 34 729.32 22.33 744.39 22.33zm4.4 43.56c5.72 0 11.11-4.18 11.11-14 0-6.82-3.63-13.53-11.11-13.53-5.94 0-11.11 4.84-11.11 13.53C737.68 60.39 742.19 65.89 748.79 65.89zM796.86 49.94v-1.1c0-11.66 17.27-16.5 17.27-25.08 0-3.74-3.63-6.49-7.81-6.49a13.07 13.07 0 0 0-5.72 1.54c-3.41 1.65-6.82 1.65-8.91-1.43l-2.64-4c-2.2-3.19-2.31-5.94 1-8A33 33 0 0 1 808.3 0c12.32 0 25.63 7.37 25.63 21.56 0 16.72-16.61 20.57-18.7 29.15L814.9 52c-.77 3-2.31 4-5.72 4h-6.27C799 56 796.86 53.9 796.86 49.94zm.44 19.91c0-4 2.09-6 6-6h5.28c4 0 6 2.09 6 6v4.4c0 4-2.09 6-6 6h-5.28c-4 0-6-2.09-6-6zM845.15 50L843.83 7.81c-.11-4 2-6.16 5.94-6.16h7.48c4 0 6 2.2 5.94 6.16L861.87 50c-.11 3.85-2.31 5.94-6.16 5.94h-4.4C847.46 56 845.26 53.9 845.15 50zm-.33 19.8c0-4 2.09-6 6-6h5.28c4 0 6 2.09 6 6v4.4c0 4-2.09 6-6 6h-5.28c-4 0-6-2.09-6-6z"/>
                </g>
            </g>
        </svg>
    );
}
}

Title.defaultProps = {
    xPos: 0,
    yPos: 0,
    width: 1314.33,
    height: 468
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/ScoreHeading.js